import Route from "./components/Routes/Routes";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <div>
		  <Route/>
    </div>
  );
}

export default App;
